import { css, SerializedStyles } from '@emotion/react';

import { styleguideColors as COLORS, styleguideFontSize as FONT_SIZE, styleguideFontWeight as FONT_WEIGHT } from '@/Client/Styles/kaiShikiTokens';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { styleguideFontFamily as FONT, styleguideLetterSpacing as LETTER_SPACING } from '@kaiizen/kai-shiki/core';

import { ACCENT } from '../scanVideoMediaStyles';

/**
 * Presentation kept separate from KaiNavGroupVideoUnreadChip's own logic, the same way
 * TaskStatusBadge's `styles` prop does — a re-skin spreads
 * `DEFAULT_KAI_NAV_GROUP_VIDEO_UNREAD_CHIP_STYLES` and overrides only what differs.
 */
export type KaiNavGroupVideoUnreadChipStyles = {
  chip: SerializedStyles;
  iconSize: number;
};

export const DEFAULT_KAI_NAV_GROUP_VIDEO_UNREAD_CHIP_STYLES: KaiNavGroupVideoUnreadChipStyles = {
  /** Prototype `grp-chip`: the video-surface accent, mono micro caps. */
  chip: css`
    label: KAI_NAV_GROUP_VIDEO_UNREAD_CHIP;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 2px 6px;
    background: ${ACCENT};
    color: ${COLORS.ink};
    font-family: ${FONT.mono};
    font-size: ${pxToRem(FONT_SIZE.monoMicro)};
    font-weight: ${FONT_WEIGHT.bold};
    letter-spacing: ${LETTER_SPACING.monoLabel};
    text-transform: uppercase;
    white-space: nowrap;

    svg {
      flex: none;
    }
  `,
  iconSize: 13,
};
